import { render, staticRenderFns } from "./AvailabilityChart.vue?vue&type=template&id=545429dc"
import script from "./AvailabilityChart.vue?vue&type=script&lang=js"
export * from "./AvailabilityChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports